import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import * as Models from '../../models/models-index';

@Injectable({ providedIn: 'root' })
export class AuthManagementService {
  private authApi = `${environment.baseV5ApiUri}/auth`;
  private serviceAccountsApi = `${environment.baseV5ApiUri}/service-accounts`;

  constructor(private http: HttpClient) { }

  getSessions(): Observable<Models.UserSession[]> {
    return this.http.get<Models.UserSession[]>(`${this.authApi}/sessions`);
  }

  revokeSession(sessionId: string): Observable<void> {
    return this.http.delete<void>(`${this.authApi}/sessions/${sessionId}`);
  }

  getDeveloperCredentials(): Observable<Models.DeveloperCredential[]> {
    return this.http.get<Models.DeveloperCredential[]>(`${this.authApi}/developer-credentials`);
  }

  createDeveloperCredential(request: Models.CreateDeveloperCredentialRequest): Observable<Models.CreatedDeveloperCredential> {
    return this.http.post<Models.CreatedDeveloperCredential>(`${this.authApi}/developer-credentials`, request);
  }

  revokeDeveloperCredential(credentialId: string): Observable<void> {
    return this.http.delete<void>(`${this.authApi}/developer-credentials/${credentialId}`);
  }

  getServiceAccounts(): Observable<Models.ServiceAccount[]> {
    return this.http.get<Models.ServiceAccount[]>(this.serviceAccountsApi);
  }

  getServiceAccount(id: string): Observable<Models.ServiceAccount> {
    return this.http.get<Models.ServiceAccount>(`${this.serviceAccountsApi}/${id}`);
  }

  createServiceAccount(request: Models.CreateServiceAccountRequest): Observable<Models.ServiceAccount> {
    return this.http.post<Models.ServiceAccount>(this.serviceAccountsApi, request);
  }

  updateServiceAccount(id: string, request: Models.UpdateServiceAccountRequest): Observable<Models.ServiceAccount> {
    return this.http.put<Models.ServiceAccount>(`${this.serviceAccountsApi}/${id}`, request);
  }

  createServiceAccountCredential(serviceAccountId: string, request: Models.CreateMachineCredentialRequest): Observable<Models.CreatedDeveloperCredential> {
    return this.http.post<Models.CreatedDeveloperCredential>(`${this.serviceAccountsApi}/${serviceAccountId}/credentials`, request);
  }

  revokeServiceAccountCredential(serviceAccountId: string, credentialId: string): Observable<void> {
    return this.http.delete<void>(`${this.serviceAccountsApi}/${serviceAccountId}/credentials/${credentialId}`);
  }
}
